import React, { Component } from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';

class RelatedFODRecord extends Component {


  getDateString = (value) =>
  {
  return (value) ? moment(new Date(value)).format("MM/DD/YYYY h:mm A") : "";
  }

  getYesNo = (value) =>
  {
  return (value && (value === 1 || value === "1")) ? "Yes" : "No";
  }

  render()
  {
    return (
      <Paper elevation={3}>
      <Table size="small">
      <TableBody>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>FOD ID:</TableCell>
        <TableCell>{this.props.record.FOD_ID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>FPA ID:</TableCell>
        <TableCell>{this.props.record.FPA_ID}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Source System Type:</TableCell>
        <TableCell>{this.props.record.SOURCE_SYSTEM_TYPE}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Source System:</TableCell>
        <TableCell>{this.props.record.SOURCE_SYSTEM}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>NWCG Reporting Agency:</TableCell>
        <TableCell>{this.props.record.NWCG_REPORTING_AGENCY}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>NWCG Reporting Unit ID:</TableCell>
        <TableCell>{this.props.record.NWCG_REPORTING_UNIT_ID}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>NWCG Reporting Unit Name:</TableCell>
        <TableCell>{this.props.record.NWCG_REPORTING_UNIT_NAME}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Source Reporting Unit:</TableCell>
        <TableCell>{this.props.record.SOURCE_REPORTING_UNIT}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Source Reporting Unit Name:</TableCell>
        <TableCell>{this.props.record.SOURCE_REPORTING_UNIT_NAME}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Local Fire Report ID:</TableCell>
        <TableCell>{this.props.record.LOCAL_FIRE_REPORT_ID}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Local Incident ID:</TableCell>
        <TableCell>{this.props.record.LOCAL_INCIDENT_ID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Code:</TableCell>
        <TableCell>{this.props.record.FIRE_CODE}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Name:</TableCell>
        <TableCell>{this.props.record.FIRE_NAME}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>ICS209 Join ID:</TableCell>
        <TableCell>{this.props.record.ICS_209_PLUS_INCIDENT_JOIN_ID}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>ICS209 Complex Join ID:</TableCell>
        <TableCell>{this.props.record.ICS_209_PLUS_COMPLEX_JOIN_ID}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>MTBS ID:</TableCell>
        <TableCell>{this.props.record.MTBS_ID}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>MTBS Fire Name:</TableCell>
        <TableCell>{this.props.record.MTBS_FIRE_NAME}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Complex Name:</TableCell>
        <TableCell>{this.props.record.COMPLEX_NAME}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Year:</TableCell>
        <TableCell>{this.props.record.FIRE_YEAR}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Discovery Date:</TableCell>
        <TableCell>{this.props.record.DISCOVERY_DATE}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Discovery Day of Year:</TableCell>
        <TableCell>{this.props.record.DISCOVERY_DOY}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Discovery Time:</TableCell>
        <TableCell>{this.props.record.DISCOVERY_TIME}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>NWGC Cause Classification:</TableCell>
        <TableCell>{this.props.record.NWCG_CAUSE_CLASSIFICATION}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>NWGC General Cause:</TableCell>
        <TableCell>{this.props.record.NWCG_GENERAL_CAUSE}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Age Category:</TableCell>
        <TableCell>{this.props.record.NWCG_CAUSE_AGE_CATEGORY}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Containment Date:</TableCell>
        <TableCell>{this.props.record.CONT_DATE}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Containment Day of Year:</TableCell>
        <TableCell>{this.props.record.CONT_DOY}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Containment Time:</TableCell>
        <TableCell>{this.props.record.CONT_TIME}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Fire Size:</TableCell>
        <TableCell>{this.props.record.FIRE_SIZE}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Fire Size Class:</TableCell>
        <TableCell>{this.props.record.FIRE_SIZE_CLASS}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Latitude:</TableCell>
        <TableCell>{this.props.record.LATITUDE}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>Longitude:</TableCell>
        <TableCell>{this.props.record.LONGITUDE}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>Owner Description:</TableCell>
        <TableCell>{this.props.record.OWNER_DESCR}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>State:</TableCell>
        <TableCell>{this.props.record.STATE}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{fontWeight:"bold"}}>County:</TableCell>
        <TableCell>{this.props.record.COUNTY}</TableCell>
        <TableCell style={{fontWeight:"bold"}}>FIPS Code:</TableCell>
        <TableCell>{this.props.record.FIPS_CODE}</TableCell>
      </TableRow>
      </TableBody>
      </Table>
      </Paper>
  )
  }
}

export default RelatedFODRecord;
